import { ValueFormatterParams } from 'ag-grid-community';
import { NO_VALUE } from '../../Ticker';
import { isNotNil } from '@benzinga/utils';
import { absColDef, AdvancedColDef } from '../helpers/advancedHeader';
import { comparators, getCellValueOrDefault } from '../helpers';

export const PercentNumberColDef = (colDef: AdvancedColDef, scalar: number): AdvancedColDef => ({
  cellStyle: { textAlign: 'left' },
  filter: 'agNumberColumnFilter',
  valueFormatter: (params: ValueFormatterParams) => {
    if (isNotNil(params.value)) {
      const num = parseFloat(params.value);
      if (isNaN(num)) {
        return NO_VALUE;
      }
      return num !== 0 ? `${(num * scalar).toFixed(2)}%` : NO_VALUE;
    }
    return NO_VALUE;
  },
  valueGetter: colDef.valueGetter ?? getCellValueOrDefault,
  ...colDef,
  ...absColDef({
    ...colDef,
    comparator: colDef.comparator ?? comparators.numberComparator,
  }),
});
